<div
  class="mg-message-box"
  *ngIf="contentSlot"
  [@inOutAnimation]>
  <ng-content select="mg-message-box-content"></ng-content>
</div>
